export default __webpack_public_path__ + "static/media/sample-2.bd809e20.png";